import React, { useCallback, useContext } from 'react';
import CommentBox from '../../../CommentBox/presets/CommentBox';
import { CommentContext } from '../../CommentContext';
/** A comment edit view we use for most comment presets. As of writing, this is just our CommentBox with some filled in fields. */ const EditView = ({ className, canPostComment, onCommentUpdated })=>{
    const { comment, setEditingState } = useContext(CommentContext);
    const onCloseEditor = useCallback(()=>{
        setEditingState('none');
    }, [
        setEditingState
    ]);
    const onEditDone = useCallback((result)=>{
        setEditingState('none');
        onCommentUpdated && result.comment && onCommentUpdated(result);
    }, [
        setEditingState,
        onCommentUpdated
    ]);
    return /*#__PURE__*/ React.createElement(CommentBox, {
        className: className,
        onPublishSuccess: onEditDone,
        id: `edit-${comment.commentId}`,
        commentableType: comment.typeId,
        commentableItemId: comment.itemId,
        editComment: comment,
        autoFocus: true,
        onClose: onCloseEditor,
        canPostComment: canPostComment
    });
};
EditView.displayName = 'EditView';
export default EditView;

//# sourceMappingURL=EditView.js.map